import { useCallback } from 'react';
import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import { useCurrentPlanLabel } from './use-current-plan-label';

/**
 * Which statement the banner made. The event reports it, so the ids are fixed: `messages` is the
 * email branch, and `profiles` is the object-profiles branch.
 */
export type OverageBannerId = 'multi' | 'messages' | 'profiles' | 'mau';

export function useTrackLimitsBannerClick(): (bannerId: OverageBannerId) => void {
  const { account } = useAuth();
  const { track } = useAnalytics();
  const currentPlan = useCurrentPlanLabel();

  return useCallback(
    (bannerId: OverageBannerId) => {
      void track('plan_billing', 'limitsBannerLearnMoreClicked', {
        'Account Id': account.id,
        'Current Plan': currentPlan,
        'Banner Id': bannerId,
      });
    },
    [account.id, track, currentPlan],
  );
}
